import{commonBaseInputStyles as m}from"./common/commonBaseInputStyles.js";import{styled as o}from"@mui/joy";import t from"@mui/joy/Input";var s=o(t)(({theme:o})=>({...m(o)}));export{s as BaseInput};
//# sourceMappingURL=BaseInput.js.map